import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import Handsontable from 'handsontable';

export async function exportHandsontableToXlsx(
  hot: Handsontable,
  filename = 'wire.xlsx'
) {
  const wb = new ExcelJS.Workbook();
  wb.creator = 'WIRE';
  wb.created = new Date();

  const ws = wb.addWorksheet('Data', {
    views: [{ state: 'frozen', ySplit: 1 }]
  });

  const headers = hot.getColHeader() as string[];
  const data: any[][] = hot.getData(); // visual order

  // -----------------------------
  // 1) Add header row
  // -----------------------------
  ws.addRow(headers);

  const headerRow = ws.getRow(1);
  headerRow.font = {
    name: 'Arial',
    bold: true
  };
  headerRow.alignment = {
    vertical: 'middle',
    horizontal: 'center',
    wrapText: true
  };
  headerRow.height = 22;

  ws.autoFilter = {
    from: { row: 1, column: 1 },
    to: { row: 1, column: headers.length }
  };

  // -----------------------------
  // 2) Add data rows
  // -----------------------------
  const nameColIndex = headers.indexOf('Name');
  const populatedData = data.filter(rowVals => {
    const name = nameColIndex >= 0 ? rowVals[nameColIndex] : rowVals[0];
    return name !== null && name !== undefined && String(name).trim() !== '';
  });

  for (const rowVals of populatedData) {
    const row = ws.addRow(rowVals);
    row.font = { name: 'Arial' };
    row.alignment = { vertical: 'top', wrapText: true };
  }

  // -----------------------------
  // 3) Auto-size columns to content
  // -----------------------------
  const MAX_WIDTH = 50;
  const MIN_WIDTH = 10;
  const PADDING = 2;

  headers.forEach((_, colIndex) => {
    let maxLength = 0;

    const headerValue = headers[colIndex];
    if (headerValue) {
      maxLength = headerValue.toString().length;
    }

    for (const row of populatedData) {
      const cell = row[colIndex];
      if (cell !== null && cell !== undefined) {
        const cellLength =
          cell instanceof Date
            ? 10
            : String(cell).length;
        maxLength = Math.max(maxLength, cellLength);
      }
    }

    const width = Math.min(
      MAX_WIDTH,
      Math.max(MIN_WIDTH, maxLength + PADDING)
    );
    ws.getColumn(colIndex + 1).width = width;
  });

  // -----------------------------
  // 4) Write file
  // -----------------------------
  const buffer = await wb.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }),
    filename
  );
}
